"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    MuiInput: {
        root: {
            'label + &': {
                marginTop: 6,
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dGZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL292ZXJyaWRlcy90ZXh0ZmllbGQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxrQkFBZSxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDdkIsUUFBUSxFQUFFO1FBQ1IsSUFBSSxFQUFFO1lBQ0osV0FBVyxFQUFFO2dCQUNYLFNBQVMsRUFBRSxDQUFDO2FBQ2I7U0FDRjtLQUNGO0NBQ0YsQ0FBQyxDQUFDIn0=